// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container--22jaG","image":"styles__image--373lN","text":"styles__text--27wLl","title":"styles__title--2MooR","subtitle":"styles__subtitle--3-DML"};
    if(module.hot) {
      // 1546575129168
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  